import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=37f0b6b8&scoped=true&"
import script from "./basket.vue?vue&type=script&lang=js&"
export * from "./basket.vue?vue&type=script&lang=js&"
import style0 from "./basket.vue?vue&type=style&index=0&id=37f0b6b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0b6b8",
  null
  
)

export default component.exports